import { render, staticRenderFns } from "./ModelStandards.vue?vue&type=template&id=0ae3d97e&"
import script from "./ModelStandards.vue?vue&type=script&lang=ts&"
export * from "./ModelStandards.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports